import { render, staticRenderFns } from "./issue_due_date.vue?vue&type=template&id=e39c5bd6&"
import script from "./issue_due_date.vue?vue&type=script&lang=js&"
export * from "./issue_due_date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports